import React from 'react';

interface ModulePlaceholderProps {
  title: string;
  status?: string;
}

export const ModulePlaceholder: React.FC<ModulePlaceholderProps> = ({
  title,
  status = 'Scheduled for v2',
}) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-12">
    <h2 className="text-2xl font-black text-hr-indigo tracking-tight mb-2">{title}</h2>
    <div className="flex items-center gap-2 mb-6">
      <span className="h-2 w-2 rounded-full bg-amber-500" />
      <span className="text-micro font-bold text-amber-600 uppercase tracking-widest">
        {status}
      </span>
    </div>
    <p className="max-w-md text-slate-500 text-xs leading-relaxed">
      This module is intentionally not part of v1. The roadmap, archived implementations, and
      integration requirements are documented in <code>docs/V2-ROADMAP.md</code>.
    </p>
  </div>
);
